(function() {
    angular
        .module("app")
        .config(appRouter)

    appRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function appRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){
        $stateProvider
            .state("/", {
                url: "/",
                templateUrl: "app/components/devices/devices.view.html",
                controller : "DevicesController"
            })
            .state("support", {
                url: "/support",
                templateUrl: "app/components/support/support.view.html",
                controller : "SupportController"
            })

            $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
